var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AbstractManager {
  constructor(base) {
    __publicField(this, "__base");
    this.__base = base;
    this.__hideProperties(["__base"]);
  }
  get __element() {
    return this.__base.$el;
  }
  get __config() {
    return this.__base.__config;
  }
  get __eventsManager() {
    return this.__base.__events;
  }
  __hideProperties(properties) {
    Object.defineProperties(
      this,
      Object.fromEntries(
        properties.map((property) => [
          property,
          {
            enumerable: false,
            writable: false,
            value: this[property]
          }
        ])
      )
    );
  }
}
export {
  AbstractManager
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
